import React, { useState } from "react";
import { useParams } from "react-router-dom";
// react admin
import {
  Pagination,
  Datagrid,
  DateField,
  List,
  NumberField,
  TextField,
  FunctionField,
  useListContext,
} from "react-admin";
// mui
import {
  Box,
  Button,
  Chip,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField as MuiTextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const CustomFilter = () => {
  const { setFilters } = useListContext();

  const [selectedField, setSelectedField] = useState("username");
  const [filterValue, setFilterValue] = useState("");

  const handleApply = () => {
    if (filterValue.trim() === "") return;
    setFilters({ [selectedField]: filterValue }, {});
  };

  const handleClear = () => {
    setSelectedField("username");
    setFilterValue("");
    setFilters({}, {});
  };

  return (
    <Box
      display={{ xs: "block", width: "100%", sm: "flex" }}
      alignItems="center"
      gap={2}
    >
      <Box display="flex" width="max-content">
        <FormControl>
          <InputLabel>Filter By</InputLabel>
          <Select
            size="small"
            value={selectedField}
            label="Search By"
            onChange={(e) => setSelectedField(e.target.value)}
            sx={{ marginRight: "10px", minWidth: 120 }}
          >
            <MenuItem value="username">Username</MenuItem>
            <MenuItem value="publicEmail">Email</MenuItem>
            <MenuItem value="manager">Manager</MenuItem>
          </Select>
        </FormControl>
        <MuiTextField
          size="small"
          variant="outlined"
          value={filterValue}
          onChange={(e) => setFilterValue(e.target.value)}
          placeholder="Enter value"
        />
      </Box>

      <Box display="flex">
        <Button
          variant="contained"
          sx={{
            marginTop: "10px",
            marginBottom: "10px",
            marginRight: "10px",
            background: "#FFC107",
            color: "#0A0A0A",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FFA000",
            },
          }}
          onClick={handleApply}
        >
          Search
        </Button>
        <Button
          variant="outlined"
          sx={{
            marginTop: "10px",
            marginBottom: "10px",
            marginRight: "10px",
            outline: "1px solid #FFC107",
            color: "white",
            textTransform: "none",
          }}
          onClick={handleClear}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export const UserHierarchy = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const params = useParams();
  const id = params.id;

  return (
    <React.Fragment>
      <Box
        sx={{
          mt: 4,
          backgroundColor: "#242424",
          borderRadius: 2,
          boxShadow: "none !important",
          padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
        }}
      >
        <List
          //   title="Recharge Records"
          resource="usersHierarchy"
          filters={<CustomFilter />}
          filter={{ userId: id }}
          sort={{ field: "createdAt", order: "DESC" }}
          actions={null}
          pagination={<Pagination />}
          sx={{
            "& .RaList-actions": {
              flexWrap: "nowrap",
            },
            "& .RaFilterFormInput-spacer": { display: "none" },
          }}
          empty={<EmptyComponent />}
        >
          <Box
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Box
              style={{
                width: "100%",
                position: isSmallScreen ? "absolute" : "relative",
              }}
            >
              <Datagrid
           
                bulkActionButtons={false}
                sx={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  width: "100%",
                  maxHeight: "100%",
                  "& .RaDatagrid-table": {
                    width: "100%",
                  },
                }}
              >
                <TextField source="username" label="Username" />
                <TextField source="publicEmail" label="Email" />
                <TextField source="phone" label="Phone" />
                <FunctionField
                  label="Role"
                  source="roleName"
                  render={(record) => {
                    const getColor = (status) => {
                      switch (status) {
                        case "Super-User":
                          return "primary";
                        case "Game-Owner":
                          return "primary";
                        case "Master-Distributor":
                          return "secondary";
                        case "Distributor":
                          return "error";
                        case "Sub-Distributor":
                          return "warning";
                        case "Agent":
                          return "info";
                        case "Player":
                          return "success";
                        default:
                          return "default";
                      }
                    };
                    return (
                      <Chip
                        label={record.roleName}
                        color={getColor(record.roleName)}
                        size="small"
                        variant="outlined"
                      />
                    );
                  }}
                />
                <NumberField source="balance" textAlign="left" />
                <DateField source="createdAt" label="Register date" showTime />
                <TextField source="managerName" label="Manager" />
              </Datagrid>
            </Box>
          </Box>
        </List>
      </Box>
    </React.Fragment>
  );
};
const EmptyComponent = () => (
  <div style={{ textAlign: "center", padding: "20px", color:"white" }}>
    <p>No User Hierarchy Found</p>
  </div>
);
